/*@flow*/
import type { Node } from 'react';
import React from 'react';
import AsyncDropdown from 'comps/AsyncDropdown';

const customStyles = {
  input: (base) => ({ ...base, border: 'none', color: '#6394c4' }),
  valueContainer: (base) => ({ ...base, paddingLeft: 0, paddingBottom: 4 }),
  menu: (base) => ({ ...base, color: 'black', borderRadius: 0 }),
  control: (base) => ({
    ...base,
    border: 'none',
    borderBottom: 'solid 1px #6394c4',
    borderRadius: 0,
    boxShadow: 'none',
    background: 'transparent',
    ':hover': {
      borderBottom: 'solid 1px #6394c4',
    },
  }),
  placeholder: (base) => ({ ...base, color: '#6394c4' }),
  multiValue: (base) => ({
    ...base,
    background: 'transparent',
    border: 'solid 1px #6394c4',
    marginBottom: 3,
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#6394c4',
  }),
  clearIndicator: (base) => ({
    ...base,
    color: '#6394c4',
    ':hover': {
      color: 'white',
    },
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#6394c4',
    borderRadius: 0,
    borderLeft: 'solid 1px #6394c4',
    marginLeft: 3,
    ':hover': {
      color: 'white',
      background: 'transparent',
    },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base) => ({
    ...base,
    color: '#6394c4',
    ':hover': {
      color: 'white',
    },
  }),
};

type PropsT = {
  className?: string,
  value: any,
  loadValues?: (input?: string) => Promise<any[]>,
  name?: string,
  classNamePrefix?: string,
  placeholder: ?string,
  onChange: (any) => any,
};

export default (props: PropsT): Node => {
  const {
    className,
    placeholder,
    name,
    value,
    loadValues,
    classNamePrefix,
    onChange,
  } = props;

  return (
    <AsyncDropdown
      isCreatable={false}
      className={className}
      classNamePrefix={classNamePrefix || 'Select'}
      name={name}
      loadValues={loadValues}
      isMulti
      value={value}
      styles={customStyles}
      placeholder={placeholder}
      onChange={onChange}
    />
  );
};
